import { FileClock, RotateCcw, Trash2 } from "lucide-react";
import { minutesAgo } from "@/lib/drafts";
import { Button } from "@/components/ui/button";

const GOLD = "#C9A84C";

/** Prominent, non-blocking restore offer. Stays until the user chooses — no timeout. */
export const DraftPrompt = ({ draft, label = "draft" }) => {
  if (!draft?.offer) return null;
  const count = Object.keys(draft.offer.values || {}).length;
  return (
    <div
      className="mb-3 border p-3.5 animate-in fade-in slide-in-from-top-2 duration-300"
      style={{ borderColor: "rgba(201,168,76,0.45)", background: "rgba(201,168,76,0.09)" }}
      role="alertdialog"
      aria-live="polite"
      data-testid="draft-restore-prompt"
    >
      <div className="flex flex-wrap items-center gap-3">
        <FileClock className="w-5 h-5 shrink-0" style={{ color: GOLD }} />
        <p className="flex-1 min-w-[220px] text-[13px]" data-testid="draft-restore-message">
          You have an unsaved {label} from{" "}
          <strong>{minutesAgo(draft.offer.saved_at)}</strong>. Would you like to restore it?
          <span className="block text-[11.5px] text-muted-foreground mt-0.5">
            {count} field{count === 1 ? "" : "s"} saved on this device.
          </span>
        </p>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onClick={draft.restore}
            className="font-semibold"
            style={{ background: GOLD, color: "#0A1628" }}
            data-testid="draft-restore-btn"
          >
            <RotateCcw className="w-3.5 h-3.5 mr-1.5" /> Restore Draft
          </Button>
          <Button size="sm" variant="outline" onClick={draft.discard} data-testid="draft-discard-btn">
            <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Discard
          </Button>
        </div>
      </div>
    </div>
  );
};

export const DraftRestoredBanner = ({ draft }) => {
  if (!draft?.restored) return null;
  return (
    <div
      className="mb-1 border px-3 py-2 text-[12.5px]"
      style={{ borderColor: "rgba(201,168,76,0.4)", background: "rgba(201,168,76,0.08)", color: GOLD }}
      data-testid="draft-restored-banner"
    >
      Draft restored — please review before saving.
    </div>
  );
};
